jQuery('.filter-nav button').click(function(){
	
	//start new feed based on category
	
	//clear all existing items
	jQuery( '.writing-item' ).remove();
	
	//set page to 0
	jQuery('.results').attr( 'data-page', '0' );
	
	//get post type
	var type = jQuery( '.results' ).data( 'type' );
	
	//get category
	var filter = jQuery( this ).data( 'category' );
	
	//clear-set active classes			
	jQuery('.filter-nav button.active').removeClass('active');
	jQuery(this).addClass('active');
	
	
	load_more('0', type, filter);

});

jQuery(document).on("click", "#loadmore", function(){ 
	
	var page = jQuery('#loadmore').data('page');
	var type = jQuery( '.results' ).data( 'type' );
	var filter = jQuery('.filter-nav button.active').data('category');
	
	load_more( page, type, filter );
	
});

jQuery('.controls button').click(function(){ 
	
	var slide = jQuery('.slide.active').data('order');
	
	var next = parseInt(slide) + 1;
	var prev = parseInt(slide) - 1;
	
	var slides = jQuery( '.slide' ).map(function() {
			
		return jQuery (this ).data( 'order' );
		
	}).get();
		
	var max = Math.max.apply( Math, slides );
	
	var elem = '';
	
	jQuery('.slide.active').removeClass('active');
	
	if( prev < 1 ) {
		
		prev = max;
		
	}
	
	if ( next > max ) {
		
		next = 1;
		
	}
	
	if( jQuery(this).hasClass('prev') ) {
		
		elem = '.slide[data-order="' + prev + '"]';
		
	}
	
	if( jQuery(this).hasClass('next') ) {
		
		elem = '.slide[data-order="' + next + '"]';
		
	}
	
	jQuery( elem ).addClass('active');
		
});

jQuery( document ).ready(function(){

	jQuery('.carousel-slider').slick({
		centerMode: true,
	  	centerPadding: '400px',
	  	slidesToShow: 1,
		infinite: true,
		slidesToScroll: 1,
		dots: false,
		autoplay: false,
		autoplaySpeed: 2000,
		arrows: false,
		//prevArrow:'<button type="button" class="slick-prev"><i class="fa-solid fa-left-long"></i></button>',
		//nextArrow:'<button type="button" class="slick-next"><i class="fa-solid fa-right-long"></i></button>',
		responsive: [
			{
			  breakpoint: 720,
			  settings: {
		      	centerMode: false,
		      	//adaptiveHeight: true
			  }
			}
		]			
	});
	
});

jQuery('.gallery-slider button').click(function(){  
	
	if( jQuery(this).hasClass('slick-prev') ) {
		
		jQuery('.carousel-slider').slick('slickPrev');
		
	}
	
	if( jQuery(this).hasClass('slick-next') ) {
		
		jQuery('.carousel-slider').slick('slickNext');
		
	}
	
});

jQuery('.filter-nav h4').click(function(){  
	
	if ( jQuery( window ).width() < 900 ) {
		
		jQuery('.filter-nav').toggleClass('mobile-open');
		
	}
	
});